import { render, staticRenderFns } from "./CopySms.vue?vue&type=template&id=454e5dc3&scoped=true"
import script from "./CopySms.vue?vue&type=script&lang=js"
export * from "./CopySms.vue?vue&type=script&lang=js"
import style0 from "./CopySms.vue?vue&type=style&index=0&id=454e5dc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454e5dc3",
  null
  
)

export default component.exports